/**
 * @file paddle Wave Summit 2020 活动卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';
import {Col, Row} from 'antd';

import A from '../../../../components/a/A';

import activeItemIcon1 from './image/active-item1.png';
import activeItemIcon2 from './image/active-item2.png';
import activeItemIcon3 from './image/active-item3.png';
import activeItemIcon4 from './image/active-item4.png';
import {IActivityListProps} from './types';


const preFixedZero = (num: number, n?: number) => {
    if (n === undefined) return num;
    if (`${num}`.length >= n) return num;
    return (Array(n).join('0') + num).slice(-n);
};

const ActiveList: React.FC<IActivityListProps> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);

    const {
        qrcode,
        qrcodeLink,
        qrcodeTitle
    } = props;

    const imgMap = useMemo(() => {
        return [
            activeItemIcon1,
            activeItemIcon2,
            activeItemIcon3,
            activeItemIcon4
        ];
    }, []);

    return (
        <div className="paddle-ws2020-activity">
            <Row gutter={[40, 40]}>
                {list.map((item, index) => (
                    <Col xs={24} sm={12} md={6} key={index}>
                        <div className="paddle-ws2020-activity-item">
                            <div className="paddle-ws2020-activity-item-inner">
                                <div
                                    className="paddle-ws2020-activity-item-icon"
                                    style={{backgroundImage: imgMap[index] ? `url(${imgMap[index]})` : undefined}}
                                />
                                <div className="paddle-ws2020-activity-item-stepnum">{preFixedZero(index + 1, 2)}</div>
                                <div className="paddle-ws2020-activity-item-title">
                                    {item.title}
                                </div>
                                <div className="paddle-ws2020-activity-item-text">
                                    {item.text}
                                </div>
                                {!!item.btnText
                                && (
                                    <div className="paddle-ws2020-activity-item-btn-group">
                                        <A
                                            className="paddle-ws2020-activity-item-btn"
                                            target
                                            href={item.btnLink}
                                        >
                                            {item.btnText}
                                        </A>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            <div className="paddle-ws2020-activity-qrcode-wrap">
                <A href={qrcodeLink} target>
                    <div
                        className="paddle-ws2020-activity-qrcode-img"
                        style={{backgroundImage: qrcode ? `url(${qrcode})` : undefined}}
                    >
                        <img alt={qrcodeTitle} src={qrcode} />
                    </div>
                    <div
                        className="paddle-ws2020-activity-qrcode-title"
                    >
                        {qrcodeTitle}
                    </div>
                </A>
            </div>
        </div>
    );
};

export default ActiveList;
